var categories = {
    'Food': '#32a852',
    'People': '#2F6B9A',
    'Home': '#82a6c2',
    'Places': '#E63946',
    'Animals': '#F77F00',
    'Vehicles': '#06D6A0',
    'Colours': '#FFD166',
    'Activities': '#1B4332',
    'Actions': '#F472B6',
    'Adjectives': '#0077B6',
    'Things': '#7209B7',
    'Phrases': '#143059',
};
var getCategoryOptions = function () {
    return Object.keys(categories).map(function (c) { return ({ value: c, label: c }); });
};
var getColourForCategory = function (category) {
    if (categories[category]) {
        return categories[category];
    }
    return '#666';
};
export { getCategoryOptions, getColourForCategory };
